import * as React from "react";

const ArrowIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
    >
        <path
            stroke="#368FAA"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M18.5 12H5M13 18s6-4.419 6-6-6-6-6-6"
        ></path>
    </svg>
);

export default ArrowIcon;
